import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, map, toArray} from 'rxjs/operators';

@HookClass('text')
export class TextHook {

    @Hook('75e7df1c-db91-4222-84ae-f9bd69c1d9e4')
    public templateReplace(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        let template = input.object.config.template;

        const format$ = (value: any, key: any) => {
            if (typeof value == 'string') {
                return value.replace(new RegExp(`\{\{${key}\}\}`, 'g'), input.object.data[key]);
            } else if (value instanceof Array)
                value.forEach((templateItem: any) => templateItem = format$(templateItem, key));
            else if (value instanceof Object)
                Object.keys(value).forEach((property: any) => value[property] = format$(value[property], key));

            return value;
        };

        Object.keys(input.object.data).forEach((key: string) => {
            template = format$(template, key);
        });

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = template;
        return of(outputArtifact);
    }

    @Hook('c614ef5f-cdcc-47a2-87ba-14fb0ef833bf')
    public regexReplace(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = input.object.data.replace(new RegExp(input.object.regex, 'g'), input.object.replace);
        return of(outputArtifact);
    }

    @Hook('1485418e-2261-46f4-a965-046add3b41c0')
    public split(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        if (input.object.data.value?.split)
            outputArtifact.object = input.object.data.value.split(`${input.object.config.separator}`);

        return of(outputArtifact);
    }

    @Hook('3217b0f7-1453-46aa-bc58-d792055793c8')
    public fromBase64(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        if (input.object.config?.toString)
            outputArtifact.object = Buffer.from(input.object.data, 'base64').toString();
        else
            outputArtifact.object = Buffer.from(input.object.data, 'base64');

        return of(outputArtifact);
    }

    @Hook('78ced812-d7fa-40f6-877c-ab35a5b28e30')
    public validateCpf(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const cpf = input.object.data;
        let requirementsFullfilled : boolean = true;
        if (cpf == null) {
            requirementsFullfilled = false;
        }
        if (cpf.length != 11) {
            requirementsFullfilled =  false;
        }
        if (['00000000000','11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'].includes(cpf)) {
            requirementsFullfilled =  false;
        }

        let digit: number = 0;
        let char: string = '';
        let digits: string = '0123456789';
        let j: number = 10;
        let sum: number = 0;
        let mod: number = 0;
        let digit1: number = 0;
        let digit2: number = 0;
        let cpfBackup: string = '';
        cpfBackup = cpf.substring(0, 9);

        if (requirementsFullfilled) {
            for (let i: number = 0; i < 9; i++) {
                char = cpfBackup.charAt(i);
                if (digits.search(char) == -1) {
                    requirementsFullfilled = false;
                }
                else {
                    digit = Number(char);
                    sum = sum + (digit * j);
                    j--;
                }
            }

        }
        if (requirementsFullfilled) {
            mod = sum % 11;
            digit1 = 11 - mod;
            if (digit1 > 9) {
                digit1 = 0;
            }
            j = 11;
            sum = 0;
            cpfBackup = cpfBackup + digit1;
            for (let i: number = 0; i < 10; i++) {
                char = cpfBackup.charAt(i);
                digit = Number(char);
                sum = sum + (digit * j);
                j--;
            }
            mod = sum % 11;
            digit2 = 11 - mod;
            if (digit2 > 9) {
                digit2 = 0;
            }
            cpfBackup = cpfBackup + digit2;
            requirementsFullfilled = cpf == cpfBackup
        }

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = {};
        outputArtifact.object.isValid = requirementsFullfilled;
        return of(outputArtifact);
    }

    @Hook('79212ba4-ab90-4492-b611-55e137b102f9')
    public join(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = null;

        let value = input.object.data;

        if (input.object.config?.field?.split)
            value = input.object.data
                .map((_value: any) => input.object.config?.field.split('.')
                    .reduce((o: any, i: any) => (o ? o[i] : o), _value));

        if (value?.join)
            outputArtifact.object = value.join(`${input.object.config?.separator}`);

        return of(outputArtifact);
    }

    @Hook('c762feb3-6691-45cf-97d0-86f44e1d3f46')
    public formatMoney(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        let template: string;
        let toBd: any;
        if (input?.object?.config?.toBD == undefined || input?.object?.config?.toBD == 'false')
            toBd = false;
        else
            toBd = true;

        switch (input.object.config.currency) {
            case  'BRL':
                template = 'R$ ';
                break;

            case 'USD':
                template = 'US$ ';
                break;

            case 'NONE':
                template = '';

                break;


        }
        return from(Object.keys(input.object.data))
            .pipe(map((key: string) => {
                if (toBd) {
                    if (input.object.data[key] != undefined)
                        input.object.data[key] = (parseFloat((input.object.data[key]).toString().replace(new RegExp(/\./, 'g'), '').replace(',', '.')).toFixed(3)).toString();
                    else
                        input.object.data[key] = null;
                } else {
                    input.object.data[key] = (parseFloat(input.object.data[key]).toFixed(2).toString().replace(new RegExp(/\./, 'g'), ','));
                    input.object.data[key] = template.concat(input.object.data[key]);
                }
            }), toArray())
            .pipe(concatMap(() => {
                return of(input);
            }));

    }

    @Hook('76d47171-63a7-4836-8b0b-406fbd2d548f')
    public validateRegex(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const regex = new RegExp(input.object.config.regex);
        const value = input.object.data;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = {};
        outputArtifact.object.isValid = regex.test(value);
        return of(outputArtifact);
    }

    @Hook('bbcd6af1-271c-4602-869a-251ec26db068')
    public parseByReference(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        let source = input.object.data;

        if (input.object?.config?.split && input.object?.data?.split)
            source = input.object.data.split(input.object.config.splitChar);

        const parse$ = (value: any) => {
            if (value instanceof Array)
                value = value.map((templateItem: any) => parse$(templateItem));
            else if (value instanceof Object)
                Object.keys(value).forEach((property: any) => value[property] = parse$(value[property]));
            else
                return value = input.object.config.terms[value];

            return value;
        };

        if (source != undefined)
            source = parse$(source);
        else
            source = input.object.config.default;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = source;
        return of(outputArtifact);
    }

    @Hook('532515f6-099a-4168-8c0d-b65538b2367f')
    public stringToJson(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const dataToParse = inputArtifact.object.data;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = JSON.parse(dataToParse);
        return of(outputArtifact);
    }

    @Hook('a7f2424e-c3ed-4949-8327-62e642374094')
    public stringApply(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        let data = input.object.data;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        // @ts-ignore
        if (data instanceof Array) {
            // @ts-ignore
            outputArtifact.object = String.prototype[input.object.config.name].apply(...data);
        } else {
            // @ts-ignore
            outputArtifact.object = String.prototype[input.object.config.name].apply(data);
        }
        return of(outputArtifact);
    }

    @Hook('8abce1bb-d50b-47b2-aea0-711a8bf765e5')
    public objectToArray(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const data = input.object.data;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        // Check if data is an object and if is null
        if (typeof data === 'object' && data !== null) {
            // Apply the Object.entries() method to the object and map it
            outputArtifact.object = Object.entries(data).map(([key, value]) => ({ key, value }));
        } else {
            // Exception
            throw new Error('Not an object');
        }

        return of(outputArtifact);
    }

    @Hook('606108aa-2303-44f8-9e6d-3cb7f0d8c828')
    public objectAssign(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = Object.assign({}, ...input.object.data);
        return of(outputArtifact);
    }

    @Hook('a2abffa3-4c70-4e71-b6cd-81f3a561493c')
    public turnKeysAndValuesToObject(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = input.object.data;
        // Check if data is an array and if is null
        if (input.object.data !== null) {
            input.object.data.forEach((item: any) => {
                if (item[input.object.config.attributesKey] instanceof Array) {
                    const transformedObject: { [key: string]: string } = {};
                    item[input.object.config.attributesKey].forEach((pick: any) => {
                        const fieldKey = input.object.config.fieldKey.split('.')
                            .reduce((o: any, i: any) => (o ? o[i] : o), pick);
                        const fieldValue = input.object.config.fieldValue.split('.')
                            .reduce((o: any, i: any) => (o ? o[i] : o), pick);
                        transformedObject[fieldKey] = fieldValue;
                    });
                    item[input.object.config.attributesKey] = transformedObject;
                }
            });
        } else {
            // Exception
            outputArtifact.kind = ArtfactKind.ERROR;
            outputArtifact.object = new Error('Not an Array');
            return of(outputArtifact);
        }
        outputArtifact.object = input.object.data;
        return of(outputArtifact);
    }

    @Hook('bf46fb5f-6bf7-45f1-a2d3-bf88e34e762c')
    public encode(input: NickProcessArtfact): Observable<NickProcessArtfact> {
      const data = input.object.data;

      const outputArtifact = new NickProcessArtfact();
      outputArtifact.kind = ArtfactKind.ANY;

      outputArtifact.object = encodeURI(data);

      return of(outputArtifact);

    }

    @Hook('4f2d1081-fc0a-449c-b9ca-fc83383cffd9')
    public decode(input: NickProcessArtfact): Observable<NickProcessArtfact> {
      const data = input.object.data;

      const outputArtifact = new NickProcessArtfact();
      outputArtifact.kind = ArtfactKind.ANY;

      outputArtifact.object = decodeURI(data);

      return of(outputArtifact);
    }

    @Hook('ad161022-0051-459c-90f3-e3c9322f9c8e')
    public convertNumberInFull(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const innerDict = {
            "0": "zero",
            "1": "um",
            "2": "dois",
            "3": "três",
            "4": "quatro",
            "5": "cinco",
            "6": "seis",
            "7": "sete",
            "8": "oito",
            "9": "nove",
            "10": "dez",
            "11": "onze",
            "12": "doze",
            "13": "treze",
            "14": "quatorze",
            "15": "quinze",
            "16": "dezesseis",
            "17": "dezessete",
            "18": "dezoito",
            "19": "dezenove",
            "20": "vinte",
            "30": "trinta",
            "40": "quarenta",
            "50": "cinquenta",
            "60": "sessenta",
            "70": "setenta",
            "80": "oitenta",
            "90": "noventa",
            "100": "cento",
            "200": "duzentos",
            "300": "trezentos",
            "400": "quatrocentos",
            "500": "quinhentos",
            "600": "seiscentos",
            "700": "setecentos",
            "800": "oitocentos",
            "900": "novecentos",
        }
        const outerDict = [
            "", "mil", ["milhão", "milhões"], ["bilhão", "bilhões"], ["trihão", "trihões"]
        ]

        const data = input.object.data;
        const config = input.object.config;

        const numberArrays = data.toString().replaceAll(".", "").split("");
        const outerGroup = ((characterArray) => {
            const reversedCharacterArray = characterArray.reverse()
            let result: string[][] = [[]]
            let index = 0
            while(reversedCharacterArray.length) {
                if(result[index].length > 2) {
                    index++;
                    result.push([])
                }
                result[index].push(reversedCharacterArray.shift())
            }
            return result.map(sub => sub.reverse()).reverse()
        })(numberArrays);
        const innerGroupT = outerGroup.map(group => {
            let result = []
            if(group.join("") == '100') {
                result.push('cem')
            }
            else {
                // @ts-ignore
                if(innerDict[group.join("")]) {
                    // @ts-ignore
                    result.push(innerDict[group.join("")])
                }
                else {
                    while (group.length) {
                        let _number = parseInt(group.shift());
                        if (_number == 0) continue;
                        const _idx = _number * (10 ** (group.length));
                        // @ts-ignore
                        let _result = innerDict[_idx];
                        result.push(_result);
                    }
                }
            }
            return result.join(" e ")
        })

        let result = ""
        let rIndex = 0
        for(let index=innerGroupT.length - 1; index >= 0; index--) {
            if(innerGroupT[rIndex] == '') {
                rIndex++;
                continue;
            }
            if(result != "") result += " e "
            let _outer = outerDict[index]
            if(Array.isArray(_outer)) {
                _outer = innerGroupT[rIndex].includes('um') ? _outer[0] : _outer[1]
            }
            let _newWord = `${innerGroupT[rIndex]}${outerDict[index] ? ' ' + _outer : ''}`;
            result += _newWord;
            if(result == 'um mil') result = 'mil'
            rIndex++;
        }

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = result;
        return of(outputArtifact);
    }

    @Hook('b2a01260-dfd5-4c23-9511-9e9c96dd1f40')
    public convertNumberInFullCurrency(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        let data = input.object.data;
        let number = data.number;
        const casas = [
            '',
            'mil',
            'milhões',
            'bilhões',
            'trilhões',
            'quatrilhões',
            'quintilhões',
            'sextilhões',
            'septilhões',
            'octilhões',
            'nonilhões',
            'decilhões',
            'undecilhões',
            'duodecilhões',
            'tredecilhões'
        ];
        const dezenas = [
            'dez',
            'onze',
            'doze',
            'treze',
            'quatorze',
            'quinze',
            'dezesseis',
            'dezessete',
            'dezoito',
            'dezenove'
        ];
        const primeiraCasa = [
            'zero',
            'um',
            'dois',
            'três',
            'quatro',
            'cinco',
            'seis',
            'sete',
            'oito',
            'nove'
        ];
        const segundaCasa = [
            '',
            'dez',
            'vinte',
            'trinta',
            'quarenta',
            'cinquenta',
            'sessenta',
            'setenta',
            'oitenta',
            'noventa'
        ];
        const terceiraCasa = [
            '',
            'cento',
            'duzentos',
            'trezentos',
            'quatrocentos',
            'quinhentos',
            'seiscentos',
            'setecentos',
            'oitocentos',
            'novecentos'
        ];
        const nomes = [primeiraCasa, segundaCasa, terceiraCasa
        ];

        const getGroup = ((number: any) => {
            if (number == '100')
                return 'cem';

            let output = '';
            for (let i = 0; i < number.length; i++) {
                let c = number[i];
                if (output) {
                    if (c == '0')
                        continue;
                    output += ' e ';
                }

                if (((number.length == 2 && i == 0) || (number.length == 3 && i == 1)) && c == '1')
                    return output + dezenas[+number[i + 1]];

                output += nomes[number.length - i - 1][+c];
            }

            return output;
        });

        const numberInFull = ((number: any) => {
            let output = [],
                numbers = [];

            number = number.toString();
            while (number.length > 0) {
                let piece = number.length <= 3 ? number : number.substr(number.length - 3, 3);
                numbers.push({number: +piece, name: getGroup(piece)});
                number = number.length - 3 > 0 ? number.substr(0, number.length - 3) : '';
            }

            if (numbers.length == 1 && numbers[0].number == 0)
                return numbers[0].name;

            for (var i = numbers.length - 1; i > 0; i--)
                if (numbers[i].number != 0)
                    output.push(numbers[i].name + ' ' + (numbers[i].number == 1 ? casas[i].replace('ões', 'ão') : casas[i]));

            if (numbers.length && numbers[0].number > 0)
                output.push(`${(numbers.length > 1 && (numbers[0].number < 100 || numbers[0].number % 100 == 0) ? 'e ' : '')}${numbers[0].name}`);
            else if (output.length > 1)
                output.splice(output.length - 1, 0, 'e');

            return output.join(' ');
        });

        let numberStr: any = number.toString().replace('-', '').split('.');
        let numberBefore: any = numberStr[0] || 0;
        let numberAfter: any = (numberStr[1] + '00').substring(0, 2);

        let numberBeforeExtended = (number < 0 ? 'menos' : '') + numberInFull(numberBefore);
        let numberAfterExtended = numberInFull(numberAfter);

        const result = (numberBefore > 0 ? numberBeforeExtended + (numberBefore == 1 ? ' real' : ' reais') : '') +
            (numberAfter > 0 ? (numberBefore > 0 ? ' e ' : '') + numberAfterExtended + (numberAfter == 1 ? ' centavo' : ' centavos') : '')

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = result;
        return of(outputArtifact);
    }
}
